import { Permissions } from '@kudos/http-client'
import {
  AccountPermission,
  AnnouncementPermission,
  AppPermission,
  AuthFactorPermission,
  AwardPermission,
  AwardTypePermission,
  BudgetItemPermission,
  CardBackgroundPermission,
  CardContributorPermission,
  CardPermission,
  ChannelPermission,
  CheckInPermission,
  CommentPermission,
  CustomRewardOrderPemissions,
  CustomRewardPermissions,
  CustomRewardProviderPermission,
  CustomRewardVariantPermission,
  DelegationPermissionsEnum,
  FtpConnectionPermission,
  IncentivePermission,
  PhotoPermissionsEnum,
  PostPermissions,
  RecognitionPermission,
  ReportPermissions,
  ResourcePermission,
  RewardProviderPermission,
  SamlProviderPermission,
  SpacePermissions,
  StaffRecordPermissionsEnum,
  TangoProviderPermission,
  TeamAutomationPermission,
  TeamPermission,
  TenantMemberPermission,
  TransactionRecipientPermission,
  UserPermission,
  ValuePermission,
} from '.'

/**
 * @method hasPermission
 * @description takes in an object which contains a __permissions__ prop and checks to see if the string exists in the array of strings
 * @prop entity
 * @prop permission
 * @returns boolean
 */
export const hasPermission = (
  entity: Permissions,
  permission:
    | TenantMemberPermission
    | SamlProviderPermission
    | AppPermission
    | ChannelPermission
    | UserPermission
    | AuthFactorPermission
    | CheckInPermission
    | TeamPermission
    | ValuePermission
    | RecognitionPermission
    | CommentPermission
    | BudgetItemPermission
    | ResourcePermission
    | TeamAutomationPermission
    | RewardProviderPermission
    | CustomRewardProviderPermission
    | CustomRewardPermissions
    | CustomRewardOrderPemissions
    | AwardTypePermission
    | AwardPermission
    | CardPermission
    | CardContributorPermission
    | CardBackgroundPermission
    | ReportPermissions
    | AnnouncementPermission
    | TangoProviderPermission
    | IncentivePermission
    | TransactionRecipientPermission
    | AccountPermission
    | StaffRecordPermissionsEnum
    | FtpConnectionPermission
    | CustomRewardVariantPermission
    | DelegationPermissionsEnum
    | SpacePermissions
    | PostPermissions
    | PhotoPermissionsEnum,
): boolean =>
  !!entity?.__permissions__?.length ? entity.__permissions__.includes(permission) : false
